import { useMemo } from 'react';
import { useAppSelector } from '../store/hooks';
import { selectUser } from '../store/auth';

export const useIsGranted = (permission?: string[] | string | undefined) => {
    const user = useAppSelector(selectUser);

    return useMemo(
        () => user
            ? permission
                ? Array.isArray(permission)
                    ? permission.map(p => user.permissions.includes(p))
                        .reduce((a, b) => a && b, true)
                    : user.permissions.includes(permission)
                : true
            : false,
        [user, permission]
    );
};
